__turbopack_context__.v({
  "controls": "ImageGalleryBlock-module-scss-module__ydEeuW__controls",
  "controls__navigation": "ImageGalleryBlock-module-scss-module__ydEeuW__controls__navigation",
  "controls__pagination": "ImageGalleryBlock-module-scss-module__ydEeuW__controls__pagination",
  "controls__previous": "ImageGalleryBlock-module-scss-module__ydEeuW__controls__previous",
  "image-gallery": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery",
  "image-gallery--dawn": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--dawn",
  "image-gallery--dawn-2": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--dawn-2",
  "image-gallery--dusk": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--dusk",
  "image-gallery--light-dusk": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--light-dusk",
  "image-gallery--midnight": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--midnight",
  "image-gallery--midnight-2": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--midnight-2",
  "image-gallery--warm-red": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery--warm-red",
  "image-gallery__body": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery__body",
  "image-gallery__heading": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery__heading",
  "image-gallery__image": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery__image",
  "image-gallery__inner": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery__inner",
  "image-gallery__slide": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery__slide",
  "image-gallery__swiper": "ImageGalleryBlock-module-scss-module__ydEeuW__image-gallery__swiper",
});
